<template>
    <div id="modal-sinisters-list-component">
        <div class="animated fadeIn">
            <div class="row">

            </div>
        </div>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";

export default {
    name: 'modal-sinisters-list',
    props: {
        month: {
            type: Number,
            required: false
        },
        supplier_id: {
            type: Number,
            required: false
        }
    },
    mixins: [myMixins],
    data() {
        return {

            tituloBtn: 'Agregar Nota',
        }
    },
    methods: {
        async index() {

        },

    },
    mounted() {
        this.index();
    }
}
</script>
